/** @format */

import { reducerDebug } from '../../core/debug';
import { paymentDispositionConstants } from './actions';

export type PaymentDispositionReducerType = {
    type: string;
    selectedValue?: string;
    valueChange?: boolean;
};

export const paymentDispositionReducers = (state = {}, action: PaymentDispositionReducerType): object => {
    reducerDebug('paymentDisposition reducer: ' + action.type);
    switch (action.type) {
        case paymentDispositionConstants.SELECT_CHANGE:
            return {
                ...state,
                ...action,
            };
        default:
            return state;
    }
};
